<p class="qundis-inter-400">Bitte den Arbeitsplatz definieren</p>
<form class="admin-form workstation-form" [formGroup]="workstationForm">
  <mat-form-field>
    <mat-label>Name des Arbeitsplatzes</mat-label>
    <input matInput type="text" formControlName="name" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Arbeitsplatz ID</mat-label>
    <input matInput type="text" formControlName="workstation_id" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Position</mat-label>
    <input matInput type="text" formControlName="position" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Produktionslinienindex</mat-label>
    <input matInput type="text" formControlName="productionLineIndex" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Produktionslinie</mat-label>
    <mat-select formControlName="productionLine">
      <mat-option
        *ngFor="let productionLine of productionLineService.productionLines()"
        [value]="productionLine.id"
      >
        {{ productionLine.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Status</mat-label>
    <mat-select formControlName="status">
      <mat-option [value]="true">aktiv</mat-option>
      <mat-option [value]="false">inaktiv</mat-option>
    </mat-select>
  </mat-form-field>
</form>

<app-save-cancel-buttons
  [backRoute]="'/admin/workstations'"
  (saveEvent)="onSave()"
></app-save-cancel-buttons>
